import { combineReducers } from 'redux';
import UsersReducer from './users';
import SearchPreferencesReducer from './searchPreferences';
import BrowseReducer from './browse';

export default combineReducers({
  users: UsersReducer,
  searchPreferences: SearchPreferencesReducer,
  browse: BrowseReducer,
});